<template>
	<div class="site_box flex2">
		<div class="site_nav flex3">
			当前位置：
			<span @click="goHome">首页</span>>
			<span>{{lone}}</span>>
			<span>{{ltwo}}</span>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		lone: {
			type: String,
			required: true,
		},
		ltwo: {
			type: String,
			required: true,
		}
	},
	data() {
		return {

		}
	},
	methods: {
		goHome() {
			this.$router.push('/');
		}
	}
}
</script>

<style lang="scss">
.site_box {
	background-color: #f3f3f3;
	.site_nav {
		width: 1300px;
		height: 60px;
		color: #868686;
		font-size: 16px;
		span {
			margin-left: 8px;
			margin-right: 8px;
			cursor: pointer;
			&:hover {
				color: #cf2437;
			}
			&:nth-child(1) {
				margin-left: 0;
			}
			&:nth-child(3) {
				color: #cf2437;
			}
		}
	}
}
@media screen and (max-width: 1600px) {
	.site_box {
		.site_nav {
			width: 1200px;
		}
	}
}
@media screen and (max-width: 1400px) {
	.site_box {
		.site_nav {
			width: 1100px;
		}
	}
}
@media screen and (max-width: 1300px) {
	.site_box {
		.site_nav {
			width: 1000px;
		}
	}
}
</style>